<template>
  <div class="hb-empty">
    <feather-icon :icon="icon" size="28" class="hb-empty__icon" />
    <p class="hb-empty__title">{{ title }}</p>
    <div v-if="$slots.default" class="hb-empty__action">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * Estado vazio de um painel de aba.
 *
 * Uma linha, sem prosa — a densidade do backoffice e essa ("Nenhum registro encontrado").
 * Secoes cujo dado ainda nao existe no backend nao usam isto: elas simplesmente nao sao
 * renderizadas.
 */
export default {
  name: 'HbEmptyState',
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: 'InboxIcon' },
  },
}
</script>

<style scoped>
.hb-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  padding: 2.5rem 1rem;
  text-align: center;
}

.hb-empty__icon {
  color: var(--text-muted);
}

.hb-empty__title {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
</style>
